var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuex-table',{staticClass:"table--content-middle",attrs:{"fields":_vm.fields,"table_store":"pbx/contacts/table"},scopedSlots:_vm._u([{key:"last_name",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'pbx.contact.edit', params: { id: item.id } }}},[_vm._v(" "+_vm._s(item.last_name)+" "+_vm._s(item.first_name)+" ")])]}},{key:"contact_methods",fn:function(ref){
var value = ref.formatted;
return [_c('contact-method-list-collapse',{attrs:{"items":value}})]}},{key:"actions",fn:function(ref){
var item = ref.item;
return [_c('table-control',{attrs:{"type":"trash"},on:{"click":function($event){return _vm.remove_item(item)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }